import { Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
import LandingPage from './pages/LandingPage'
import DeviceConfigurator from './pages/DeviceConfigurator'
import RoutingPage from './pages/RoutingPage'
import SeaOverridesPage from './pages/SeaOverridesPage'
import { AppRoutes as DemoAppRoutes } from './app/app-routes'

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />} path="/">
        <Route element={<LandingPage />} path="/" />
        <Route element={<DeviceConfigurator />} path="/configurator" />
      </Route>
      <Route element={<RoutingPage />} path="/routing" />
      <Route element={<SeaOverridesPage />} path="/sea-overrides" />
      <Route path="/app/*" element={<DemoAppRoutes />} />
    </Routes>
  )
}
